<template>
  <div class="container">
    <van-search class="search" v-model="queryparams.true_name" show-action placeholder="请输入搜索关键词" @search="onSearch">
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>
    <div class="info">
      <div class="title-info">
        <img src="@/assets/images/gxqgouche2212/qiche.png" />
        <div>全市已登记数量</div>
      </div>
      <div class="num">{{ meta.count }}</div>
    </div>
    <van-empty v-if="finished && list.length <= 0" class="custom-image" :image="require('@/assets/images/gxqgouche2212/empty.png')" description="您暂无登记记录" />
    <van-list v-if="!(finished && list.length == 0)" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="list" v-for="item in list" :key="item.id">
        <div class="list-item" @click="handleDetails(item)">
          <div class="item-left">
            <img src="@/assets/images/gxqgouche2212/buddha.png" />
            <div class="item-info">
              <div class="name">{{ item.true_name }}</div>
              <div class="time">{{ item.created_at }}</div>
            </div>
          </div>
          <van-icon color="#131177" name="arrow" />
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { getList } from '@/service/gxqgouche2212/index'
export default {
  name: 'RecordList',

  data() {
    return {
      lock: true,
      queryparams: {
        true_name: '',
        page: 1,
        pagesize: 15
      },
      meta: {
        count: 0,
        currentPage: 1,
        pageCount: 1,
        perPage: 10,
        totalCount: 0
      },
      list: [],
      loading: false,
      finished: false
    }
  },
  mounted() {},
  methods: {
    onSearch() {
      this.queryparams.page = 1
      this.queryparams.pagesize = 15
      this.onLoad()
    },
    onLoad() {
      if (this.lock) {
        this.lock = false
        getList(this.queryparams).then((res) => {
          this.lock = true
          if (this.queryparams.page == 1) {
            if (res.data) {
              this.list = res.data.items
            }
          } else {
            this.list = [...this.list, ...res.data.items]
          }
          if (res.data) {
            this.meta = res.data.meta.page
          }
          // 加载状态结束
          this.loading = false
          if (this.queryparams.page >= this.meta.pageCount) {
            this.finished = true
          } else {
            this.queryparams.page++
          }
        })
      }
    },
    handleDetails(item) {
      this.$router.push({
        path: `/add-car?id=${item.id}`
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
/deep/ .custom-image .van-empty__image {
  margin-top 200px
  width: 324px;
  height: 233px;
}
.container
  padding 34px
  height 100%
  overflow-y scroll
  .search
    // border: 1px solid #cccccc
    /deep/ .van-search__content
      border: 1px solid #cccccc
      border-radius 50px 0 0 50px
    /deep/ .van-search__action
      border: 1px solid #2854F3
      background #2854F3
      color #fff
      border-radius 0 50px 50px 0
  .info
    font-size: 40px;
    display flex
    justify-content: space-between
    align-items: center
    color: #131177;
    margin-bottom 50px
    .title-info
      display flex
      align-items: center
    img
      width: 48px;
      height: 40px;
      margin-right 20px
    .num
      color red
      font-size: 40px;
  .list
    .list-item
      display flex
      justify-content: space-between
      align-items: center
      box-shadow: 0px 0px 15px 0px rgba(176, 200, 220, 0.4);
      border-radius: 10px;
      margin-bottom 30px
      padding 40px 35px
      .item-left
        display flex
        img
          width: 90px;
          height: 90px;
          margin-right 20px
        .item-info
          .name
            width 460px
            font-size: 36px;
            color: #1A1A1A;
            font-weight: bold;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          .time
            font-size: 24px;
            color: #888888;
</style>
